//
// navbar.js
// Theme module
//

const navLinks = document.querySelectorAll('.nav-item')
const navbarTogglable = document.querySelectorAll('.navbar-togglable');
const navbarCollapse = document.querySelectorAll('.navbar-collapse');
const windowEvents = ['load', 'scroll'];
let isLight = false;

function makeNavbarTransparent(navbar) {
    navbar.classList.remove('navbar-scrolled');
    isLight = false;
}
function makeNavbarSolid(navbar) {
    navbar.classList.add('navbar-scrolled');
    isLight = true;
}
function toggleNavbar(navbar) {
    const scrollTop = window.pageYOffset;
    if (scrollTop && !isLight) {
        makeNavbarSolid(navbar);
    }
    if (!scrollTop) {
        makeNavbarTransparent(navbar);
    }
}
function overflowHide() {
    const scrollbarWidth = getScrollbarWidth();
    document.documentElement.style.overflow = 'hidden';
    document.body.style.paddingRight = scrollbarWidth + 'px';
}
function overflowShow() {
    document.documentElement.style.overflow = '';
    document.body.style.paddingRight = '';
}
function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
}

navbarTogglable.forEach(function(navbar) {
    windowEvents.forEach(function(event) {
        window.addEventListener(event, function() {
            toggleNavbar(navbar);
        });
    });
});
navbarCollapse.forEach(function(collapse) {
    collapse.addEventListener('show.bs.collapse', function() {
        overflowHide();
    });
    collapse.addEventListener('hidden.bs.collapse', function() {
        overflowShow();
    });
});
document.addEventListener('click', (e) => {
    document.querySelectorAll('.navbar-collapse').forEach(function(navbar) {
        navbar.classList.remove("show")
    })
})
